<template>
  <v-main>
    <v-card class="saved-question-card pa-3 pl-6">
      <v-row>
        <v-col cols="9" md="10" lg="11" sm="10">
          <h3 class="qtext">{{ question.qtext }}</h3>

          <div class="text-center">
            <img v-if="question.image" :src="question.image" class="question-image" />
          </div>
          <v-divider class="mx-4 mb-4 mt-4"></v-divider>
          <v-switch
            disabled
            v-model="question.is_subjective"
            v-if="question.is_subjective && currentUser.is_faculty"
            label="Subjective"
          ></v-switch>
          <v-textarea
            label="Answer"
            hint="This is a subjective question."
            @change="changedSubjectiveAnswer"
            v-if="question.is_subjective && currentUser.is_student"
            filled
            auto-grow
          ></v-textarea>
          <OptionList :question="question" v-if="!question.isSubjective" />
        </v-col>
        <v-col cols="3" md="2" lg="1" sm="2">
          <h5 class="text-center">{{ question.marks }}</h5>
          <h5 class="text-center">Marks</h5>
        </v-col>
      </v-row>
      <!-- Change to is.student -->
      <div v-if="currentUser.is_faculty && showDelete">
        <v-divider class="mx-4"></v-divider>
        <div class="text-right">
          <v-btn
            color="#FF0000"
            class="ma-2 delete-question-btn"
            @click="showDeleteConfirmationDialog = true"
          >Delete Question</v-btn>
        </div>
      </div>
    </v-card>
    <DeleteConfirmationBox
      title="Are you sure you want to delete this question?"
      description="Deleting this question will also remove all the options and marks associated with it."
      :visible="showDeleteConfirmationDialog"
      @deleteObject="deleteQuestion"
    />
  </v-main>
</template>

<script>
import OptionList from "./OptionList.vue";
import DeleteConfirmationBox from "../widgets/DeleteConfirmationBox";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "QuestionCard",
  props: ["question", "showDelete"],
  data() {
    return {
      showDeleteConfirmationDialog: false,
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    ...mapActions(["addAnswer"]),

    async changedSubjectiveAnswer(text) {
      console.log(text);
      this.addAnswer({
        question: this.question.id,
        answer: text,
      });
    },

    deleteQuestion(sure) {
      this.showDeleteConfirmationDialog = false;

      if (sure) {
        this.$emit("deleteQuestion", this.question);
      }
    },
  },
  components: {
    OptionList,
    DeleteConfirmationBox,
  },
};
</script>

<style scoped>
.qtext {
  margin-bottom: 15px;
}
.delete-question-btn {
  color: white;
}
.saved-question-card {
  margin-top: 30px;
  padding: 10px;
  padding-left: 30px;
  border-left: 5px solid #009688;
  border-radius: 20px;
}
.text-center {
  text-align: center;
}
.text-right {
  padding: 20px;
  padding-bottom: 10px;
  text-align: end;
}
.question-image {
  width: 300px;
}
</style>